export const en = {
    header: {
      business: "Business",
      client: "Client",
    },
    hero: {
      title: "Fast and Reliable Payments for Business and Users",
      subtitle: "Accept cryptocurrency and fiat, instant transactions, complete security",
      businessButton: "Connect Business",
      walletButton: "Create Wallet",
    },
    features: {
      title: "Feennex Advantages",
      items: {
        fastTransactions: {
          title: "Fast Transactions",
          description: "Instant transfers in cryptocurrency and fiat",
        },
        security: {
          title: "Security",
          description: "Protection through multi-level encryption",
        },
        globalReach: {
          title: "Global Reach",
          description: "Working with clients worldwide",
        },
        flexibleSettings: {
          title: "Flexible Settings",
          description: "Adaptation for business and users",
        },
        transparency: {
          title: "Transparency",
          description: "No hidden fees",
        },
        instantSettlement: {
          title: "Instant Settlement",
          description: "Funds available for withdrawal immediately after payment T+0",
        },
      },
    },
    howItWorks: {
      title: "How Feennex Works for Business?",
      steps: {
        createAccount: {
          title: "Create Account",
          description: "Registration and payment cabinet setup",
        },
        connectApi: {
          title: "Connect API",
          description: "Simple integration into your business",
        },
        payments: {
          title: "Send and Receive Payments",
          description: "Instant transfers in cryptocurrency and fiat",
        },
        management: {
          title: "Financial Management",
          description: "Analytics, reports, conversion",
        },
      },
    },
    footer: {
      tagline: "Accept payments in cryptocurrency and fiat",
      contact: "Contact Us",
      service: "Service",
      apiDocs: "API Documentation",
      documents: "Documents",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      copyright: "Copyright © 2025 feennex.com All rights reserved",
    },
    policies: {
      aml: {
        title: "Anti-Money Laundering Policy",
        content: "... AML policy content in English ..."
      },
      privacy: {
        title: "Privacy Policy",
        content: "... Privacy policy content in English ..."
      },
      terms: {
        title: "Terms of Service",
        content: "... Terms of Service content in English ..."
      }
    },
    aml: {
        title: "AML",
        subtitle: "Anti-Money Laundering Policy (AML)",
        content: `<div class="content-block">
            <p>
                Anti-money laundering (AML) includes a set of measures aimed 
                at the prevention of the use of a financial system of a country or 
                a particular financial institution for money laundering or terrorism 
                financing. International and national institutions, banking and 
                business communities deal with the development and implementation 
                of these measures and instruments.
            </p>
            <p>
              Below are specific steps taken by Feennex in its activities as part 
              of the AML Policy:
            </p>
            <ul class="marked-list">
              <li>
                There is a top-level official in our management structure, whose 
                main task is to supervise the compliance with the policy and procedures 
                of Feennex, the best global practices and AML related statutory regulations.
              </li>
              <li>
                We trust high-skilled employees of our company working in close contact 
                with clients: these are both customer service specialists and heads of 
                divisions and departments. As part of the client policy, “Know Your Customer» 
                programme is introduced in the company, the main goal of which is to understand 
                and to be kept informed of the partners, with whom we enter into business relations.
              </li>
              <li>
                We comply with requirements of anti-money laundering legislation of Poland. 
                In cases prescribed by the relevant legal acts, the company cooperates with 
                officials and government institutions of Poland.
              </li>
              <li>
                We monitor recent global trends in anti-money laundering and implement them 
                in operation of our company.
              </li>
              <li>
                We are aware of anti-money laundering and statement of facts of terrorism 
                financing are an ongoing process requiring continuing attention and the ability 
                to track illegal financial schemes.
              </li>
            </ul>
          </div>
          <div class="content-block">
            <h4>Main resources and legal acts related to AML:</h4>
            <ol>
              <li>
                Government of Poland. "Counteracting money laundering and financing of terrorism Act" 
                (USTAWA z dnia 1 marca 2018 r. o przeciwdziałaniu praniu pieniędzy oraz finansowaniu terroryzmu) <br/>
                <a
                        href="https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20180000723"
                        target="_blank"
                        rel="nofollow noopener"
                >https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20180000723</a
                >
              </li>
              <li>Financial Action Task Force on Money Laundering <br/><a
                        href="https://www.fatf-gafi.org/en/home.html"
                        target="_blank"
                        rel="nofollow noopener"
                >https://www.fatf-gafi.org/en/home.html</a></li>
              <li>
                Office of Foreign Assets Control (OFAC) of the US Department 
                of the Treasury<br/> <a
                        href="https://home.treasury.gov/policy-issues/office-of-foreign-assets-control-sanctions-programs-and-information"
                        target="_blank"
                        rel="nofollow noopener"
                >https://home.treasury.gov/policy-issues/office-of-foreign-assets-control-sanctions-programs-and-information</a>
              </li>
              <li>
                Financial Crimes Enforcement Network<br/> <a
                      href="https://www.fincen.gov/"
                      target="_blank"
                      rel="nofollow noopener"
              >https://www.fincen.gov/</a
              >
              </li>
              <li>
                International Money Laundering Information Network <br/><a
                      href="https://www.imolin.org/"
                      target="_blank"
                      rel="nofollow noopener"
              >https://www.imolin.org/</a
              >
              </li>
            </ol>
          </div>`
    },
    privacy: {
        title: "Privacy and Data Protection Policy",
        content: `<div class="content-block">
          <p>
            The present Personal Information Privacy Policy (hereinafter referred to as “the Policy”) 
            applies to all information the Feennex payment service provider (hereinafter referred 
            to as “the Provider”) may obtain from the user of the payment system (hereinafter referred 
            to as “the Client”) in order to use by the latter the Feennex® service and/or any of the 
            web sites, applications, products, services, software of the Provider (hereinafter referred 
            to as “the Provider’s Services”).
          </p>
          <p>
            <b>IT IS OBLIGATORY FOR ALL THE DATA SUBJECTS TO READ THIS POLICY IN ORDER TO ACKNOWLEDGE 
            HOW THE PROVIDER COLLECTS, PROCESSES THE PERSONAL DATA, AND WHAT SECURITY MEASURES ARE APPLIED.</b>
          </p>
          <p>
            <b
            >The use of the Provider’s Services means that the client has read the present Policy and unreservedly 
            agrees with the terms of processing of his or her personal information specified hereof as well as 
            any other information for analyzing the behavior of Clients/Visitors on the website, for which 
            the Provider may involve third parties; if disagreed, 
            the Client must refrain from using the Provider’s Services.</b
            >
          </p>
        </div>
        <div class="content-block">
          <h4>DEFINITIONS</h4>
          <p>
            <b>Personal data</b> means any information relating to an identified or identifiable 
            natural person; an identifiable natural person is one who can be identified, 
            directly or indirectly, in particular by reference to an identifier such as a name, 
            an identification number, location data, an online identifier or to one or more 
            factors specific to the physical, physiological, genetic, mental, economic, 
            cultural or social identity of that natural person;
          </p>
          <p>
            <b>Special categories of the personal data (sensitive data)</b> means any personal 
            data revealing the racial or ethnic origin, political views, religious or 
            philosophical beliefs, membership in trade unions, as well as the processing 
            of genetic data, biometric data for the purpose of unambiguous identification 
            of a natural person, health data.
          </p>
          <p>
            <b>Data controller (controller)</b> means the natural or legal person, public 
            authority, agency or other body which, alone or jointly with others, 
            determines the purposes and means of the processing of personal data.
          </p>
          <p>
            <b>Data Subject</b> means any person being the subject of personal data, 
            whose personal data is processed by the Provider, including Users 
            (Developers, Clients and Visitors), independent contractors/employees and 
            other interested parties.
          </p>
          <p>
            <b>Client</b> means a Data Subject who has completed the registration procedure on the Platform.
          </p>
          <p>
            <b>Visitor</b> means a Data Subject who has visited the website of the Platform for any specific purpose.
          </p>
          <p>
            <b>Services</b> means any service rendered by the Provider using the Platform. 
            The services are provided pursuant to the End-User License Agreement.
          </p>
          <p>
            <b>Platform</b> means  https://${process.env.GATSBY_BASE_DOMAIN}/ website with the accompanying software 
            by the Company on the servers allowing the provision of the Services.
          </p>
          <p>
            <b>Processing</b> means any operation or set of operations which is performed on 
            personal data or on sets of personal data, whether or not by automated means, 
            such as collection, recording, organisation, structuring, storage, 
            adaptation or alteration, retrieval, consultation, use, disclosure by transmission, 
            dissemination or otherwise making available, alignment or combination, restriction, 
            erasure or destruction.
          </p>
          <p>
            <b>Automated decision-making</b> means the ability to make decisions using 
            technological aids without human intervention leading to legal consequences 
            regarding the Data Subject or significantly affecting it.
          </p>
          <p>
            <b>Personal data breach</b> means a breach of security leading to the accidental 
            or unlawful destruction, loss, alteration, unauthorised disclosure of, or access to, 
            personal data transmitted, stored or otherwise processed.
          </p>
          <p>
            <b>Consent</b> means any freely given, specific, informed and unambiguous indication 
            of the data subject’s wishes by which he or she, by a statement or by a clear affirmative 
            action, signifies agreement to the processing of personal data relating to him or her.
          </p>
          <p>
            <b>Supervisory Authority (DPA)</b> means independent public authority approved by an EU member 
            state pursuant to the General Data Protection Regulation (GDPR/RODO). Within the scope of the 
            current Policy, DPA means the Data Protection Inspectorate of Poland.
          </p>
          <p>
            <b>Mouseflow</b> is a service engaged by the Provider to provide the Service, which uses the Software 
            to process, analyze and store the Customer/Visitor Data. Mouseflow is an analytics tool used 
            by the Provider to optimize and improve the operation of the Services.
          </p>
        </div>
        <ol class="tiered-list">
        <li>
          <span>General provisions</span>
          <ol>
            <li>
              Upon collection and utilisation of the personal data, the Provider
              shall be a subject to a number of legal acts regulating the
              procedure for implementation of such activities, as well as the
              guarantees to be established in order to protect the data
            </li>
            <li>
              The present Policy shall be applied to all employees of the
              Provider, Customers, interested parties and any subjects directly
              or indirectly involved in the processing of the personal data
              within the scope of the Provider's activities, including the Data
              Subjects visiting the website https://${process.env.GATSBY_BASE_DOMAIN}/.
            </li>
            <li>
              The Data Subjects shall be entitled to contact the Provider or the
              DPA regarding their personal data breach in case they discover it
              prior to the Provider.
            </li>
          </ol>
        </li>
        <li>
          <span>Clients’ personal information</span>
          <ol>
            <li>
              For the purposes of the present Policy, the term “the Client’s
              personal information” shall be defined as the information that:
              <ol>
                <li>
                  is presented by the Client himself upon signing up at any of
                  the Provider’s Services;
                </li>
                <li>
                  is presented by the Client himself upon
                  identification/complete identification of the Client;
                </li>
                <li>
                  is presented by the Client himself upon use of any Provider’s
                  Services;
                </li>
                <li>
                  automatically delivered to the Provider and Mouseflow upon use of any
                  Provider’s Services, including IP address, cookies status, the
                  Client's browser used for accesses to the Provider’s Services,
                  access time, requested page.
                </li>
              </ol>
            </li>
            <li>
              The present Policy shall apply to the data presented by the Client
              to the Provider in use of the Services only. The Provider shall
              not be held liable for any personal information placed by the
              Client on the websites of third parties inter alia the cases when
              the link to the website is placed on the Provider’s website.
            </li>
            <li>
              The Provider shall not verify the accuracy of the personal
              information disclosed by the Client, however assumes that the
              Client has provided complete and reliable information which is
              subject to update if rectified.
            </li>
          </ol>
        </li>
        <li>
          <span
            >The terms of processing of the Client’s personal information:</span
          >
          <ol>
            <li>
                The Company shall adhere to the principles set forth by the GDPR
                upon collection and processing of the personal data. The
                Company’s policies and procedures shall be designed to ensure
                compliance with the following principles:
              <ol>
                <li>
                  <b>Lawfulness, fairness and transparency</b>
                  <p>
                    Lawfulness means the controller shall determine the
                    legitimacy of the justifications prior to the processing of
                    the personal data (for example, consent).
                  </p>
                  <p>
                    Fairness means the controller shall make certain information
                    available to the data subjects to process the data fairly to
                    the extent reasonably practicable. This applies to whether
                    the personal data was obtained directly from the data
                    subjects or from other sources.
                  </p>
                  <p>
                    Transparency means any information related to the processing
                    of the personal data shall be accessible and understandable,
                    as well as presented in a simple and understandable terms.
                  </p>
                </li>
                <li>
                  <b>Purpose limitation</b>
                  <p>
                    The personal data shall be collected for specified, explicit
                    and legitimate purposes and not further processed in a
                    manner that is incompatible with those purposes; further
                    processing for archiving purposes in the public interest,
                    scientific or historical research purposes or statistical
                    purposes shall not be considered to be incompatible with the
                    initial purposes.
                  </p>
                </li>
                <li>
                  <b>Data minimisation</b>
                  <p>
                    The personal data shall be adequate, relevant and limited to
                    what is necessary in relation to the purposes for which they
                    are processed.
                  </p>
                </li>
                <li>
                  <b>Accuracy</b>
                  <p>
                    The personal data shall be accurate and, where necessary,
                    kept up to date; every reasonable step must be taken to
                    ensure that personal data that are inaccurate, having regard
                    to the purposes for which they are processed, are erased or
                    rectified without delay.
                  </p>
                </li>
                <li>
                  <b>Storage limitation</b>
                  <p>
                    The personal data shall be kept in a form which permits
                    identification of the data subjects for no longer than is
                    necessary for the purposes for which the personal data are
                    processed. The personal data may be stored for longer
                    periods insofar as the personal data will be processed
                    solely for archiving statistical purposes subject to
                    implementation of the appropriate technical and
                    organisational measures required by the GDPR in order to
                    safeguard the rights and freedoms of the data subject.
                  </p>
                </li>
                <li>
                  <b>Integrity and Confidentiality</b>
                  <p>
                    The personal data shall be processed in a manner that
                    ensures appropriate security of the personal data, including
                    protection against unauthorised or unlawful processing as
                    well as against accidental loss, destruction or damage,
                    using appropriate technical or organisational measures.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              The Provider shall collect and store only the Client’s personal
              information that is used within the scope of the End-User License
              Agreement between the Client and the Provider on the delivery of
              the Provider’s Services, with exception where the legislation of
              Poland specifies otherwise.
            </li>
            <li>
              The confidentiality of the Client’s personal information shall be
              ensured.
            </li>
            <li>
              The Provider shall utilise the personal information for the
              following purposes:

              <ol>
                <li>
                  Within the scope of the End-User License Agreement between the
                  Client and the Provider on the delivery of the Provider’s
                  Services;
                </li>
                <li>Communication with the Client;</li>
                <li>
                  Improving the quality of the Provider’s Services, offering the
                  Client personalised Provider’s Services;
                </li>
                <li>
                  Performing the marketing actions and events for the Clients.
                </li>
              </ol>
            </li>
            <li>
              The Provider shall transfer the Client’s personal information in
              the following cases:
              <ol>
                <li>
                  The Client has consent to the transfer of the data to third
                  parties;
                </li>
                <li>
                  The transfer is required for the implementation of the
                  Provider’s obligations under the End-User License Agreement
                  between the Client and the Provider on the delivery of the
                  Provider’s Services;
                </li>
                <li>
                  The transfer is stipulated by the legislation of Poland or the
                  country of the service provision;
                </li>
                <li>
                  The Provider has reasonable grounds to believe that the
                  Client’s actions breach the terms of the End-User License
                  Agreement between the Client and the Provider on the delivery
                  of the Provider’s Services and/or the legislation of Poland.
                </li>
              </ol>
            </li>
            <li>
              Upon processing of the Client’s personal data, the Provider shall
              be a subject to the Law of Poland On the Personal Data (<a
                  href="https://isap.sejm.gov.pl/isap.nsf/download.xsp/WDU20180001000/U/D20181000Lj.pdf"
                  target="_blank"
                  >https://isap.sejm.gov.pl/isap.nsf/download.xsp/WDU20180001000/U/D20181000Lj.pdf</a
                >).
            </li>
            <li>
              Upon exercising of its activities, the Provider shall collect the
              following personal data of the Clients for the following purposes:
              <ol>
                <li>
                  Full name; payment card number; phone number; digital wallet number in payment systems; 
                  cryptocurrency wallet number; e-mail; passport details; ID card details; date of birth; 
                  photo of the wallet holder's identity, and documents provided to confirm the wallet holder's identity, 
                  photo of the payment card presenting the first 6 and last 4 digits of the card visible: IP address; 
                  and browser type are used by the Provider to render the services delivered by the Provider 
                  to the Clients regarding the money transferring without opening an account and providing 
                  electronic means of payment. The payment system or bank requires the above-mentioned personal 
                  data to ensure the payment is genuine and lawful.
                </li>
                <li>
                  nickname; photo; gender; email: phone number: and client's
                  data for instant messenger are used to manage a dialogue
                  between the Provider and the Client regarding the services.
                </li>
                <li>
                  the Provider’s website domain; email: date of birth; IP
                  address; and browser type are used to create the Client’s
                  account and to log in to the Platform.
                </li>
                <li>
                  nickname; email; phone number: client's data for instant
                  messenger: IP address; and browser type are used for
                  communication with the Client and provision of the customer
                  support regarding the login, account management, account
                  security, system software errors, Services, blocks, etc.
                </li>
              </ol>
            </li>
            <li>
              The Provider shall not collect and/or process the sensitive data.
            </li>
            <li>
              The Provider shall not apply the profiling or automated
              decision-making during the processing of the personal data.
            </li>
            <li>
              The Provider shall not collect any personal data from the Data
              Subjects other than specified in the present Policy. The Provider
              as well shall not collect any personal data except for the
              purposes of processing set forth hereof.
            </li>
            <li>
              By collecting and processing the personal data of Clients and
              Visitors, the Company acts as a controller wherefore the relevant
              range of rights and obligations arise.
            </li>
          </ol>
        </li>
        <li>
          <span
            >Rectification and erasure of the Client’s personal
            information</span
          >
          <ol>
            <li>
              The rectification and erasure of the Client’s personal information shall be 
              performed pursuant to the procedures stipulated by the End-User License Agreement 
              of the relevant Provider’s Services. Within the scope of the Provider’s Services, 
              the Client may obtain the functionality to rectify (update, add new information 
              to the data already available) or completely or partly erase the information provided 
              by the Client (according to the articles RODO - 16, 17,18,20,21), also the Client also 
              has the right to file a complaint with the supervisory authority (in accordance with Article RODO 77) 
              https://uodo.gov.pl/pl/404/224 . The use of the relevant functionality shall be a subject 
              to the agreements applicable to this Provider’s Service.
            </li>
            <li>
              The Provider shall be imposed with the obligation to process/store
              the Client’s personal information obtained upon application of the
              Provider’s Services pursuant to the legal requirements. Such
              processing/storage shall be performed by the Provider in certain
              cases, on relevant grounds and within the specified time limits
              stipulated by the legislation.
            </li>
          </ol>
        </li>
         <li>
          <span>Data processing and use by Mouseflow service</span>
          <ol>
            <li>
                This website uses Mouseflow:
                <ol>
                    <li>a website analytics tool that provides session replay, heatmaps, funnels, form analytics, 
                    feedback surveys, and similar features/functionality.</li>
                    <li>Mouseflow may record your clicks, mouse movements, scrolling, form fills (keystrokes) 
                    in non-excluded fields, pages visited and content, time on site, browser, operating system, 
                    device type (desktop/tablet/phone), screen resolution, visitor type (first time/returning), 
                    referrer, anonymized IP address, location (city/country), language, and similar meta data.</li>
                    <li>
                        Mouseflow does not collect any information on pages where it is not installed, nor does it 
                        track or collect information outside your web browser.<br/><br/>
                        <p>If you'd like to opt-out, you can do so at 
                        <a href="https://mouseflow.com/opt-out" target="_blank" rel="nofollow noopener">https://mouseflow.com/opt-out</a>.</p>
                        <p>If you'd like to obtain a copy of your data, make a correction, or have it erased, please contact 
                        us first or, as a secondary option, contact Mouseflow at 
                        <a href="mailto:privacy@mouseflow.com">privacy@mouseflow.com</a>.</p>
                        <p>For more information, see Mouseflow’s Privacy Policy at 
                        <a href="https://mouseflow.com/legal/company/privacy-policy/" target="_blank" rel="nofollow noopener">https://mouseflow.com/legal/company/privacy-policy/</a>.</p>
                        <p>For more information on Mouseflow and GDPR, visit 
                        <a href="https://mouseflow.com/legal/gdpr/" target="_blank" rel="nofollow noopener">https://mouseflow.com/legal/gdpr/</a>.</p>
                        <p>For more information on Mouseflow and CCPA/VCDPA visit 
                        <a href="https://mouseflow.com/legal/ccpa" target="_blank" rel="nofollow noopener">https://mouseflow.com/legal/ccpa</a>.</p>
                    </li>
                </ol>
            </li>
          </ol>
        </li>
        <li>
          <span>Storage period</span>
          <ol>
            <li>
              The Provider shall process and store personal data for the period
              required for the purposes of processing to be implemented as
              stipulated herein.
            </li>
            <li>
              Considering the purposes of processing, the storage period for the
              personal data (hereinafter refer to as “the Storage Period”) shall
              be as follows:
              <p>
                address; payment card number; phone number; digital wallet number in payment systems; cryptocurrency wallet number; email; passport details; taxpayer identification number; nickname; photo; date of birth; Seller’s website domain; full name; IP address; and browser type - up to 60 months from the date of the Client’s last activity on the Platform pursuant to the regulations set forth by the GDPR.
              </p>
            </li>
            <li>
              After the expiration of the storage period, the Provider shall be
              obliged to erase the personal data or shall refer to the Data
              Subject in order to sign a new consent to the data processing,
              whenever the need arises or for another purpose of processing.
            </li>
            <li>
              The Provider shall be entitled to discontinue storing subsequently
              and erase previously collected personal data of the Data Subjects
              at any time whereas such personal data are no longer required.
            </li>
            <li>
              The Provider shall continue to store personal data assuming the
              further processing is obligatory by the legislation to implement
              public interest purposes, scientific or historical research
              purposes, or statistical purposes.
            </li>
          </ol>
        </li>
        <li>
          <span>Rights of the Data Subject</span>
          <ol>
            <li>
              The present Policy enables all Data Subjects to exercise any of
              the following rights:
              <p>
                <b>he right of access.</b> The Data Subjects are entitled to
                know whether their personal data is being processed and, if so,
                to also have the access to such data.
              </p>
              <p>
                <b>the right to rectification.</b> The Data Subject shall be
                entitled to obtain from the Provider the rectification of
                inaccurate personal data concerning him or her providing a
                supplementary statement.
              </p>
              <p>
                <b>the right to erasure or the right to be forgotten.</b> The
                Data Subject shall be entitled to obtain from the Provider the
                erasure of personal data concerning him or her without undue
                delay and the Provider shall be held liable to erase such
                personal data without undue delay.
              </p>
              <p>
                <b>the right to restriction of processing.</b> The Data Subject
                shall be entitled to obtain the restriction for processing of
                personal data concerning him or her with a few exceptions within
                the scope of the GDPR.
              </p>
              <p>
                <b>the right to be informed.</b> The Provider shall be obliged
                to inform the Data Subject regarding what data is collected, how
                it is used, how long it will be stored and whether it will be
                transferred to third parties. Such information shall be concise
                and understandable.
              </p>
              <p>
                <b>the right to data portability.</b> The Data Subjects shall be
                allowed to receive and reuse their personal data for their own
                purposes in different services. This right applies only to
                personal data provided by the Data Subject to the Provider on
                the basis of consent.
              </p>
              <p>
                <b>the right to object.</b> The Data Subjects shall be entitled
                to object to processing of personal data concerning him or her
                by the Provider. The Provider must terminate the processing of
                personal data, if the Provider is unable to demonstrate a
                convincing legal basis for the processing that prevails over the
                interests, rights and freedoms of the individual or if the
                processing is intended to create or implement the protection of
                legitimate claims.
              </p>
              <p>
                <b
                  >the right not to be subject to a decision based solely on
                  automated processing.</b
                >
                The Data Subjects shall be entitled to object to any automated
                profiling occurring without consent. At the same time, the Data
                Subjects shall be entitled to obtain human intervention into the
                processing.
              </p>
            </li>
            <li>
              The Data Subject shall be entitled to exercise any of the
              above-mentioned rights by contacting the technical support at the
              following email: ${process.env.GATSBY_SUPPORT_MAIL}.
            </li>
            <li>
              The Data Subjects shall be entitled to exercise any of the above-described rights by sending a request to the following email: ${process.env.GATSBY_SUPPORT_MAIL}. The request by the Data Subject shall consist of: his or her name, personal contact details, wallet number or cryptocurrency wallet number registered in the system, email used for signing in by the user in the payment system, what right shall be exercised, the data of the subject that are processed by the Company, details and the request justification
            </li>
          </ol>
        </li>
        <li>
          <span>Security</span>
          <ol>
            <li>
              The Provider shall be held liable for ensuring that any personal
              data, held by the Provider and being a subject to its
              responsibility, is kept secure and shall not be disclosed under no
              circumstances, unless that the person has been specifically
              authorised by the Provider to obtain such information and has
              signed a non-disclosure agreement.
            </li>
            <li>
              Any personal data shall be available only to those requiring to
              use it. The personal data shall be processed with the highest
              degree of security and stored in the encrypted form.
            </li>
          </ol>
        </li>
        <li>
          <span>Notification of a personal data breach</span>
          <ol>
            <li>
              The Provider shall take all reasonable actions to minimise the
              risk of the personal data breach during its processing.
            </li>
            <li>
              In the case of a personal data breach, the Provider shall without
              undue delay and, where feasible, not later than 72 hours after
              having become aware of it, notify the personal data breach to the
              DPA unless the personal data breach is unlikely to result in a
              risk to the rights and freedoms of the Data Subjects.
            </li>
            <li>
              The risk assessment to be performed by the Provider shall
              determine the level of risk to the rights and freedoms of the Data
              Subjects once the personal data breach has occurred and whether it
              is the sufficient ground to notify the involved Data Subjects of
              such a breach.
            </li>
            <li>
              Moreover, the Provider shall notify the involved Data Subjects
              without undue delay of such a breach given the personal data
              breach may lead to a high risk to the rights and freedoms of Data
              Subjects.
            </li>
            <li>
              The notification of the involved Data Subjects shall not be
              required as stipulated by the GDPR given the measures have
              subsequently been taken to avoid a high risk to the rights of the
              Data Subjects.
            </li>
            <li>
              The Provider shall document any personal data breaches, comprising
              the facts relating to the personal data breach, its effects and
              the remedial action taken. That documentation shall enable the DPA
              to verify compliance with the GDPR.
            </li>
          </ol>
        </li>
        <li>
          <span>Data transfer</span>
          <ol>
            <li>
              The Provider shall not sell any personal data to either legal
              entities nor natural persons.
            </li>
            <li>
              The Provider shall be entitled to transfer the personal data to
              its employees specified in the present Policy. It should be
              understood that the Provider transfers the personal data pursuant
              to the GDPR.
            </li>
            <li>
              The Provider shall be entitled to transfer the personal data to
              the payment system or the bank of the Client aiming to make
              payments.
            </li>
            <li>
              The personal data shall be transferred for the purposes and under
              the conditions stipulated by the present Policy
            </li>
            <li>
              Pursuant to the GDPR, the Provider shall be entitled to transfer
              the personal data under one of the following conditions only:
              <ol>
                <li>
                  the data subject has given the express consent to the transfer
                  of data subsequent to the information received on the possible
                  risks of such transfer;
                </li>
                <li>
                  the transfer is required for the performance of a contract
                  between the data subject and the controller, or for the
                  implementation of pre-contractual measures taken at the
                  request of the data subject;
                </li>
                <li>
                  the transfer is required for the entering into or performance
                  of a contract concluded between the controller and any other
                  natural or legal person for the benefit of the data subject;
                </li>
                <li>
                  the transfer is required on the substantial grounds of the
                  public interest;
                </li>
                <li>
                  the transfer is required to generate, implement or protect the
                  legal claims;
                </li>
                <li>
                  the transfer is required to protect the vital interests of the
                  data subject or any other persons given the data subject has
                  the physical or legal incapacity to give a consent.
                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li>
          <span>Modification to the Privacy Policy</span>
          <ol>
            <li>
              The Provider shall be entitled to offer the Client to modify
              and/or supplement the present Policy by publishing the new version
              of the Policy on the website at (<a
                href="https://${process.env.GATSBY_BASE_DOMAIN}"
                target="_blank"
                rel="nofollow noopener"
                >https://${process.env.GATSBY_BASE_DOMAIN}</a
              >). Accepting by the User of such an offer means his or her
              actions evidenced by the course of conduct in application of any
              of the Provider's Services under the new conditions.
            </li>
          </ol>
        </li>
      </ol>`
    },
    agreement: {
        title: "User agreement",
        content: `<ol class="tiered-list">
            <li>
                <span>GENERAL PROVISIONS</span>
                <ol>
                    <li>
                       The User Agreement (hereinafter referred to as the Agreement) is concluded between the payment service provider Feennex (hereinafter referred to as the Provider) and the payment system user (hereinafter referred to as the User) for the purpose of using the Feennex® service and/or any of the Provider's websites, applications, products, services, software.
                    </li>
                    <li>The Agreement is accepted when registering an account on the Provider's website and means full and unconditional acceptance of all terms of the Agreement without any exceptions and/or restrictions. The User Agreement governs access to and use of <a href="/" target="_blank"
                                                                                        rel="nofollow noopener"
                        >https://${process.env.GATSBY_BASE_DOMAIN}</a>  (the "Website"), including related mobile applications (the "Applications"). The Provider's services are available to persons who have reached the age of 18, and the User confirms that his age meets the requirements of the Provider and the requirements of his country.
                    </li>
                    <li>The Provider reserves the right to amend and/or supplement this Agreement by publishing a new version on the Website. Acceptance by the User of such an offer is conclusive action regarding the use of any service of the Provider under the new conditions.
                    </li>
                    <li>
                        Definition of terms used in the Agreement:
                        <p><b>Authorization</b> is the process of analyzing and comparing the identification data entered by the User, which determines whether the User has the right to access the Provider's Services. Authorization is carried out by the Provider using software and hardware</p>
                        <p><b>Verification of the Client/User</b> – provision of documents confirming the identity of the Client/User, authorization on the Provider's website.</p>
                        <p><b>Virtual Assets</b> – cryptocurrencies or other similar digital assets previously provided by the Client to the Provider to fulfill the Client's obligations to third parties, in respect of which the User transmits orders exclusively using the Wallet.</p>
                        <p><b>Wallet</b> means an online service that allows you to store funds, transfer funds to third parties and conduct transactions for the purchase/sale of virtual assets. Wallet means a computer program, the interface of which is placed and/or available on the Internet on the Provider's Website and displayed using a program for viewing Internet sites.</p>
                        <p><b>Electronic money (electronic funds)</b> – funds previously provided by the Client to the Provider to fulfill the Client's obligations to third parties, in respect of which the Client transmits orders exclusively using the Wallet.</p>
                        <p><b>Funds</b> – electronic money and/or virtual assets.</p>
                        <p><b>Zero Balance</b> means the amount of funds available to the User for the purpose of submitting claims to the Provider for making calculations in favor of the payee, is equal to 0.00.</p>
                        <p><b>Account</b> means a user account available through the Website where transaction data and other related information are stored.</p>
                        <p><b>Feennex Service</b> means a set of services provided by the Provider to the Users for the transfer of Funds and purchase/sale/storage of virtual assets, the description and other information about which is available on the Provider's Website.</p>
                        <p><b>Tariffs</b> – a system of fees set by the Provider and posted on the Website. The Tariffs are a part of the Agreement.</p>
                        <p><b>Fiat money</b> - currency issued by the government, which is defined as legal tender in the country of issue at the legislative level.</p>
                    </li>
                </ol>
            </li>
            <li>
                <span>SUBJECT OF THE AGREEMENT</span>
                <ol>
                    <li>
                        The subject of the Agreement concluded by the User by joining through the conclusive actions provided for in this Agreement is the registration of the User's account and the provision of the following services by the Provider:
                       <p>− making payments in favor of third parties;</p>
                       <p>− purchase, sale and exchange of virtual assets for other virtual assets;</p>
                       <p>− transfer of virtual assets to other users of the Feennex Service or third parties.</p>
                    </li>
                    <li>The User is obliged to provide all information and documents required for account registration. The Provider may request additional information after activating the account, and the User is obliged to provide such information.
                    </li>
                    <li>Transaction and commission limits are set at the sole discretion of the Provider and are subject to change. The User is obliged to immediately notify the Provider if he/she does not agree with these changes, in case he/she continues to use the Feennex Service, it means that the User accepts the changes.
                    </li>
                    <li>The User acknowledges and agrees that the Provider shall not be liable for any losses incurred due to the loss of access to the Feennex Service by the User.
                    </li>
                </ol>
            </li>
            <li>
                <span>RIGHTS AND OBLIGATIONS OF THE PARTIES</span>
                <ol>
                    <li>
                        <b>Rights and obligations of the User:</b>
                        <ol>
                            <li>The User is obliged to provide all information and documents required for account registration and transactions.</li>
                            <li>The User is obliged to provide complete, truthful and accurate information in the amount required for the provision of services by the Provider.</li>
                            <li>The User undertakes to update contact information and inform the Provider of changes in personal data within 7 (seven) calendar days from the date of such changes.</li>
                            <li>The User undertakes to ensure the protection of the Wallet authentication means in order to avoid unauthorized access of third parties to personal funds. In case of suspicion of compromise of the authentication means, the User undertakes to immediately inform the Provider by contact details about these situations and events, their causes and consequences in any way available to the Client.</li>
                            <li>The User is obliged to use the Funds received from legal sources and from legal activities, and not to use the Funds received as a result of any illegal, criminal or fraudulent activity.</li>
                            <li>The User undertakes not to use anonymizers (proxy servers, sockets, distributed anonymous networks such as "tor", etc.) to work with the Provider's Services.</li>
                            <li>The User has the right to access his/her Wallet at any time convenient for him/her.</li>
                            <li>
                                The User has the right to close the Account at his/her own discretion at any convenient time, which is necessary for this:
                                <p>− withdraw the funds available on the Client's balance by transferring money using one of the methods available to the Provider;</p>
                                <p>− initiate a request for closure to the Provider's support service.</p>
                            </li>
                        </ol>
                    </li>

                    <li>
                        <b>Rights and obligations of the Provider:</b>
                        <ol>
                            <li>The Provider has the right to restrict the User's use of the Feennex Service or completely block the account if the User violates the terms of this Agreement and/or any other documents and laws referred to by the Provider.</li>
                            <li>The Provider has the right to request additional information and/or documents after activation of the account, and the User shall be obliged to provide this information and/or documents.</li>
                            <li>The Provider undertakes to provide technical support for the full and uninterrupted functioning of the Wallet.</li>
                            <li>The Provider undertakes to ensure that transactions are carried out, otherwise the Provider undertakes to provide a refund to the Wallet, minus the direct costs of the transaction, including the Provider's fee for providing the Service.</li>
                            <li>The Provider shall not be liable for the loss of the User's personal data due to the User's failure to comply with the information security rules.</li>
                            <li>
                                The Provider has the right to terminate this Agreement early and unilaterally in case of:
                                <ol>
                                    <li>− non-compliance by the User with the terms of this Agreement;</li>
                                    <li>− non-compliance by the User with the AML legislation;</li>
                                    <li>− formation by the User of a payment order for payment for goods and services prohibited (restricted) for service in the Feennex Service (the full list is given in Appendix No. 1 to this Agreement);</li>
                                    <li>− The User's Wallet has a zero balance and has not been used for 1 (one) year.</li>
                                </ol>
                            </li>
                            <li>The Service Provider has the right to block the User's account in case of suspicion of fraudulent actions on the part of the User. The Provider shall not be liable for any fraudulent actions and/or illegal activities of the User.</li>
                            <li>The Provider has the right, in accordance with the law, to suspend the User's right to use the Service in full or in part of the provision of certain services until the User passes the verification procedure again. The verification procedure is considered completed from the moment the Provider confirms the completeness and accuracy of the data provided by the User by changing the User's status in the Service.</li>
                            <li>The Provider reserves the right to refuse the User to enter into the Agreement unilaterally without further explanation.</li>
                        </ol>
                    </li>
                </ol>
            </li>
            <li>
                <span>PROCESS AND TERMS OF USER ACCOUNT REGISTRATION</span>
                <ol>
                    <li>
                        The User is allowed to register only one account of the Feennex Service. In addition, the User agrees that he/she will not use any account other than his/her own.
                    </li>
                    <li>
                        When registering a User account in the Feennex Service, it is necessary to:
                        <p>− specify an e-mail, which will be used as the User's name (login) when using the Service;</p>
                        <p>− enter a password;</p>
                        <p>− agree to the User Agreement.</p>
                    </li>
                    <li>The Provider reserves the right to request additional information during the registration and use of the account, and the User agrees to provide this information in order to continue using their account.
                    </li>
                    <li>
                        <b> Wallet without verification</b>
                        <ol>
                            <li>The User has the right to make payment transactions, including with virtual currencies, provided that
                                <p>− the amount of one transaction does not exceed EUR 50, and the account balance cannot exceed EUR 150 (or the equivalent in other means of payment provided by the Provider at the official exchange rate on the date of the payment transaction).</p>
                            </li>
                            <li>The Provider reserves the right to carry out a verification procedure to confirm the identity of the account holder.
                            </li>
                        </ol>
                    </li>
                    <li>
                        <b>Verified wallet</b>
                        <ol>
                            <li>The User has the right to make payment transactions, including with virtual currencies:
                                <p>− the transaction amount exceeds 50 EURO;</p>
                                <p>− the maximum amount of transactions per day is 14,999 EURO;</p>
                                <p>− daily account limit is 14,999 EURO.</p>
                            </li>
                            <li>The procedure for verification of the Wallet User includes:
                                <p>− indicating the place of residence;</p>
                                <p>− providing a photo of the pages of the original passport of proper quality containing the following information: user's photo, passport number, date of birth, date and authority of issuance of the document, its validity period;</p>
                                <p>− passing video verification.</p>
                            </li>
                        </ol>
                    </li> 
                    <li>
                    <!--FYI: link anchor with 88px offset (header height)-->
                    <span id="delete-account" style="position:relative; top: -88px"></span>
                        <b>Deletion of the User's account</b>
                        <p>The User has the right to delete his/her account at any time. There are several ways to delete an account:</p>
                        <ol>
                        <li>
                         Deleting an account in the Feennex Application, developed by Luardiz Corporation:
                        <p>- log in to your <b>personal account</b> in the Application by entering your login and password;</p>
                        <p>- select the <b>Profile</b> section;</p>
                        <p>- scroll down the page and select the <b>Account - Delete Account</b> section;</p>
                       <p>- after a message appears warning you that you are about to delete your account, click <b>Delete</b> account, thus confirming your desire to delete your account. </p> 
                        </li>
                        <li>
                        Delete your account on the website <a href="/" target="_blank"
                                                                                        rel="nofollow noopener"
                        >https://${process.env.GATSBY_BASE_DOMAIN}</a>:
                        <p>- log in to your <b>personal account</b> at <a href="https://wallet.${process.env.GATSBY_BASE_DOMAIN}" target="_blank"
                                                                                        rel="nofollow noopener"
                        >https://wallet.${process.env.GATSBY_BASE_DOMAIN}</a> by entering your login and password;</p>
                        <p>- select the <b>Profile - Profile Settings</b> section;</p>
                        <p>- scroll down the page and click <b>Delete Account</b>;</p>
                        <p>- after a message appears warning you that you are about to delete your account, click <b>Delete</b>, thus confirming your desire to delete your account. </p>
                        </li>
                        <li>You can also delete your account by sending a request to <a href="mailto:${process.env.GATSBY_SUPPORT_MAIL}">${process.env.GATSBY_SUPPORT_MAIL}</a>.</li>
                        <li>The terms of processing, storage periods and conditions for deleting personal information can be found in the <b>Privacy and Data Protection Policy</b> at <a href="https://${process.env.GATSBY_BASE_DOMAIN}/privacy.html" target="_blank"
                                                                                        rel="nofollow noopener"
                        >https://${process.env.GATSBY_BASE_DOMAIN}/privacy.html</a>.</li>
                        </ol>
                    </li>
                </ol>
            </li>
            <li>
                <span>PROVISION OF THE WALLET AND THE PROCEDURE FOR ITS USE</span>
                <ol>
                    <li>Payment transactions, including those using Virtual Assets, shall be carried out by the User by placing an order in the account to make an electronic transfer in favor of a specific recipient of the transfer or transactions for the sale/exchange of Funds.</li>
                    <li>By accepting this Agreement, the User confirms that he/she is aware of the possibility that due to the nature of blockchain technology and fluctuations in the value of virtual currencies, the rates of buying and selling currency may change, as well as the rates may change when the User submits an order.</li>
                    <li>The Provider may apply limits to a transaction or limits to the daily/monthly/annual volume of transactions per User's account.</li>
                    <li>The Provider reserves the right to set a time limit for any transaction and postpone its execution if there is a need to carry out additional verification, examination, investigation or any other similar activity due to internal risk management, request of official authorities or fulfillment of legal requirements. The Provider shall not be legally liable for any damages related to such actions.</li>
                    <li>The Provider does not regulate and does not control the legality of the User's agreement with the payment recipient, its terms, as well as the fact and consequences of the conclusion, execution and termination of the agreement, including in terms of refunds under such an agreement and payment by the User and/or the payment recipient of applicable taxes and fees. The Provider also does not consider the User's claims regarding the recipient's failure to fulfill (improper fulfillment) of its obligations under the Agreement, including the obligations to transfer the purchased goods and services to the User.</li>
                    <li>Fee for transfer operations within the Provider's system - 0%. Fees for replenishment of the account or transfers to other systems are available in the User's personal account.</li>
                </ol>
            </li>
            <li>
                <span>PROCEDURE FOR HANDLING CLAIMS AND DISPUTES</span>
                <ol>
                   <li>Claims of the User regarding the Feennex Service shall be accepted by the Provider for consideration only in writing and within 3 calendar days from the date of the dispute. The term for consideration of the User's claims shall not exceed 30 (thirty) business days.</li>
                   <li>All disputes and disagreements arising in the course of using the Feennex Service shall be resolved through negotiations.</li>
                   <li>If the dispute cannot be resolved in accordance with clause 6.1. of the Agreement, such a dispute shall be resolved by a competent court at the location of the Service.</li>
                </ol>
            </li>
            <li>
                <span>OTHER PROVISIONS</span>
                <ol>
                    <li>The Parties shall be released from liability for failure to fulfill their mutual obligations if their failure was the result of force majeure circumstances that arose after their accession to this Agreement, or the occurrence of extraordinary events that could not have been prevented or foreseen at the time of their occurrence. The party affected by force majeure shall notify the other party not later than 10 days after the occurrence of such circumstances.</li>
                    <li>The Provider shall not be liable for risks beyond the control of the Provider, including force majeure circumstances that have caused a complete or partial loss of collateral on the User's account, for example, in case of fire or other restrictions on access to funds providing a confirmed supply of digital currency (bankruptcy of banks, payment systems, other cases related to full or partial restriction of access to the digital currency collateral on the User's account).</li>
                    <li>Records of the Provider's databases shall take precedence over records of the Client's databases when proving the authenticity of the relevant electronic orders and messages.</li>
                    <li>The User shall not be entitled to transfer its rights and obligations arising from cooperation under the Agreement to third parties.</li>
                </ol>
            </li>
        </ol>
        <h4>
            Appendix No. 1 to the User Agreement Feennex®
        </h4>
        <p class="secondary">
            List of categories of goods and services prohibited (restricted) for service:
        </p>
        <ul class="marked-list">
            <li>Category "Adults only"</li>
            <li>Art</li>
            <li>Artifacts, goods related to burial</li>
            <li>Catalytic converters and sensor tubes</li>
            <li>Mobile (wireless) phone service contracts</li>
            <li>Ads for fundraising for charitable purposes</li>
            <li>Used cosmetics</li>
            <li>Counterfeit banknotes and stamps</li>
            <li>Credit cards</li>
            <li>Currency: sale</li>
            <li>Description of medicines or biosimilars</li>
            <li>Medicinal products and supplies</li>
            <li>Electronic equipment - examples: cable decoders, radar antennas and traffic control devices</li>
            <li>Electronic surveillance equipment - examples: electronic listening equipment and listening devices in telephones</li>
            <li>Embargoed and banned goods - example: goods from Cuba</li>
            <li>Firearms, self-defense equipment and knives - examples: pepper spray, mock weapons and stun guns.</li>
            <li>Food and health products</li>
            <li>Government documents, certificates and licenses</li>
            <li>Items related to government, transit, and delivery - examples: airplane manuals, subway uniforms, and USPS mailing bags</li>
           <li>Flammable materials - examples: batteries, fireworks and coolers</li>
            <li>Human remains and body parts</li>
            <li>Goods that incite illegal activities - example: e-book on how to make methamphetamine</li>
            <li>Lock picking devices</li>
            <li>Lottery tickets</li>
            <li>Mailing lists and personal information</li>
            <li>Manufacturers' coupons</li>
            <li>Medical devices - examples: contact lenses, pacemakers, and surgical instruments</li>
            <li>Military products (also see the section on Firearms, self-defense and knives)</li>
            <li>Multi-level marketing, pyramid schemes and matrix programs</li>
            <li>Offensive material - examples: offensive material that is inappropriate for racial or ethnic reasons and Nazi paraphernalia</li>
            <li>Pesticides</li>
            <li>Plants and seeds</li>
            <li>Goods related to law enforcement agencies</li>
            <li>Political souvenirs (reproductions)</li>
            <li>Franking machines</li>
            <li>Prescription drugs</li>
            <li>Prohibited services</li>
            <li>Real estate</li>
            <li>Recalled goods</li>
            <li>Slot machines</li>
            <li>Stamps</li>
            <li>Shares and other securities</li>
            <li>Stolen goods</li>
            <li>Surveillance equipment</li>
            <li>Tobacco products and smoking mixtures</li>
            <li>Garbage plants</li>
            <li>Precious stones and metals and products made of them</li>
            <li>Malicious software</li>
        </ul>
`
    },
};